export const PLATFORM_ORIGIN = 'https://hutsontalent.agency';

export function isCustomProfileHost(hostname = window.location.hostname) {
  const platformHosts = new Set([
    'hutsontalent.agency', 'www.hutsontalent.agency', 'localhost', '127.0.0.1', '[::1]',
    'hutsontalent-frontend.onrender.com',
    'casting-platform-dev.host', 'talent-agency-portal-1.preview.emergentagent.com',
    process.env.REACT_APP_RENDER_HOSTNAME || '',
    ...(process.env.REACT_APP_PLATFORM_HOSTS || '').split(',').map(host => host.trim().toLowerCase()).filter(Boolean),
  ]);
  return !platformHosts.has(hostname.toLowerCase());
}

export function hasCustomProfileBackend() {
  try {
    const url = new URL(process.env.REACT_APP_BACKEND_URL);
    return url.protocol === 'https:' && !url.username && !url.password && url.pathname === '/' && !url.search && !url.hash;
  } catch { return false; }
}

export async function anonymousProfileRequest(baseUrl, path, payload) {
  const response = await fetch(`${baseUrl}/api${path}`, {
    method: payload === undefined ? 'GET' : 'POST',
    credentials: 'omit',
    ...(payload === undefined ? {} : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }),
  });
  if (!response.ok) throw new Error('This profile is currently unavailable.');
  return response.json();
}
